import { render } from "./SortIcon.vue?vue&type=template&id=5ae54f33&scoped=true"
import script from "./SortIcon.vue?vue&type=script&lang=js"
export * from "./SortIcon.vue?vue&type=script&lang=js"

import "./SortIcon.vue?vue&type=style&index=0&id=5ae54f33&scoped=true&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae54f33"]])

export default __exports__